import { createMutation } from "@/mutations";
import { verifyEmail } from "@/features/auth/api/session";
import type { AxiosResponse } from "axios";
import type { TokensResponse } from "@/features/auth/api/session";

type VerifyEmailResponse = Awaited<ReturnType<typeof verifyEmail>> extends AxiosResponse<infer T>
  ? T
  : never;

export const useVerifyEmailMutation = () => {
  return createMutation<VerifyEmailResponse, string>({
    mutationFn: async (token) => {
      const response = await verifyEmail(token);
      return response.data;
    },
    invalidateQueries: (key) => Array.isArray(key) && key[0] === "userInfo",
  });
};

